<div class="card flex flex-col gap-2 rounded m-0">
  <div class="d-flex flex-column">
    <label class="form-label text-xs">
      {{ 'RegisterService::AssetQRCode' | abpLocalization }}
    </label>
    <img [width]="150" [height]="150" [src]="qrImageSrc" alt="QR Code" *ngIf="qrImageSrc" />
  </div>

  <hr />

  <div *ngIf="asset?.hours">
    <label class="form-label text-xs" for="asset-hours">
      {{ 'RegisterService::Hours' | abpLocalization }}
    </label>
    <input
      id="asset-hours"
      [value]="asset?.hours ?? null"
      class="form-control bg-gray-30 !py-2"
      readonly
    />
  </div>
  <div *ngIf="asset?.kilometers">
    <label class="form-label text-xs" for="asset-kilometers">
      {{ 'RegisterService::KM' | abpLocalization }}
    </label>
    <input
      id="asset-kilometers"
      [value]="asset?.kilometers ?? null"
      class="form-control bg-gray-30 !py-2"
      readonly
    />
  </div>
  <div>
    <label class="form-label text-xs" for="asset-barcode">
      {{ 'RegisterService::Barcode' | abpLocalization }}
    </label>
    <input
      id="asset-barcode"
      [value]="asset?.barcode ?? null"
      class="form-control bg-gray-30 !py-2"
      maxlength="64"
      readonly
    />
  </div>
  <div>
    <label class="form-label text-xs" for="asset-rfid">
      {{ 'RegisterService::Rfid' | abpLocalization }}
    </label>
    <input
      id="asset-rfid"
      [value]="asset?.rfid ?? null"
      class="form-control bg-gray-30 !py-2"
      maxlength="64"
      readonly
    />
  </div>
  <div>
    <label class="form-label" for="asset-manufacturerIdOne">
      {{ 'RegisterService::Manufacturer' | abpLocalization }} ID-1
    </label>
    <input
      id="asset-manufacturerIdOne"
      [value]="asset?.manufacturerIdOne ?? null"
      class="form-control bg-gray-30 !py-2"
      maxlength="64"
      readonly
    />
  </div>
  <div>
    <label class="form-label" for="asset-manufacturerIdTwo">
      {{ 'RegisterService::Manufacturer' | abpLocalization }} ID-2
    </label>
    <input
      id="asset-manufacturerIdTwo"
      [value]="asset?.manufacturerIdTwo ?? null"
      class="form-control bg-gray-30 !py-2"
      maxlength="64"
      readonly
    />
  </div>
  <h3 *ngIf="attributes.length" class="text-base font-medium text-black-base">
    {{ 'RegisterService::CustomAttributes' | abpLocalization }}
  </h3>
  <div *ngFor="let attribute of attributes; let i = index; trackBy: track.by('name')">
    <label class="form-label text-xs" for="asset-attributes-{{ i }}">{{ attribute.name }}</label>
    <input
      id="asset-attributes-{{ i }}"
      class="form-control bg-gray-30 !py-2"
      [value]="attribute?.value ?? null"
    />
  </div>

  <hr />

  <h3 class="text-base font-medium text-black-base">
    {{ 'RegisterService::Meters' | abpLocalization }}
  </h3>
  <div *ngFor="let meter of meters; let i = index; trackBy: track.by('name')">
    <label class="form-label text-xs" for="asset-meters-{{ i }}">
      {{ meter.name }}
    </label>
    <input
      id="asset-meters-{{ i }}"
      class="form-control bg-gray-30 !py-2"
      [value]="meter?.startReading ?? null"
    />
  </div>

  <div
    class="flex w-full justify-between rounded p-2 items-center gap-3"
    [ngStyle]="{
      background:
        asset?.isAvailable ?? false
          ? 'linear-gradient(270deg, #D5F7D2 0%, #F7F9FA 50.18%)'
          : 'linear-gradient(270deg, #FFDBDE 0%, #F7F9FA 50.18%)'
    }"
  >
    <div class="form-check" *ngIf="asset?.isRecalled">
      <input
        type="checkbox"
        id="asset-is-recalled"
        [checked]="asset?.isRecalled ?? false"
        class="form-check-input"
        (click)="$event.preventDefault()"
        readonly
      />
      <label for="asset-is-recalled" class="form-check-label text-orange">
        {{ 'RegisterService::Recalled' | abpLocalization }}
      </label>
    </div>

    <div class="form-check" *ngIf="!(asset?.isRecalled ?? false)">
      <input
        type="checkbox"
        id="asset-is-active"
        [checked]="asset?.isActive ?? false"
        class="form-check-input"
        (click)="$event.preventDefault()"
        readonly
      />
      <label
        for="asset-is-active"
        class="form-check-label"
        [ngClass]="asset?.isActive ?? false ? 'text-green' : 'text-red'"
      >
        {{ 'RegisterService::IsActive' | abpLocalization }}
      </label>
    </div>
    <div class="flex items-center gap-1">
      <label class="text-sm text-gray">
        {{ 'RegisterService::Availability:' | abpLocalization }}
      </label>
      <label
        ><p
          class="text-sm font-medium"
          [ngClass]="asset?.isAvailable ?? false ? 'text-green' : 'text-red'"
        >
          {{
            asset?.isAvailable
              ? ('RegisterService::Available' | abpLocalization)
              : ('RegisterService::NotAvailable' | abpLocalization)
          }}
        </p></label
      >
    </div>
  </div>
</div>
